import { CustomPropertyValues } from '@evidentid/tprm-portal-lib/models/dashboard/CustomProperty.model';
import { EntityInput } from '@evidentid/tprm-portal-lib/models/dashboard/Entity.model';

function normalizePhoneNumber(value: string | null | undefined): string | null {
    if (!value) {
        return null;
    }
    const digits = value.replace(/[^\d+]+/g, '');
    if (!digits) {
        return null;
    }
    return digits[0] !== '+' ? `+1${digits}` : digits;
}

function isNotEmpty(value: unknown): boolean {
    if (value === null || value === undefined || value === '') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    return true;
}

export function buildEntityInputFromFormValues(
    formValues: Record<string, any>,
): EntityInput {
    const insuredFields: CustomPropertyValues = {};
    const exceptions: Record<string, string> = {};

    for (const [ key, value ] of Object.entries(formValues)) {
        if (key.startsWith('insuredFields.')) {
            const propKey = key.slice('insuredFields.'.length);
            if (isNotEmpty(value)) {
                insuredFields[propKey] = value;
            }
        } else if (key.startsWith('exceptions.')) {
            const reqType = key.slice('exceptions.'.length);
            if (value) {
                exceptions[reqType] = value;
            }
        }
    }

    const phone = normalizePhoneNumber(formValues.contactPhoneNumber);

    return {
        displayName: formValues.displayName || '',
        contactEmail: formValues.contactEmail || '',
        ...(isNotEmpty(formValues.contactName) ? { contactName: formValues.contactName } : {}),
        ...(isNotEmpty(formValues.legalName) ? { legalName: formValues.legalName } : {}),
        ...(phone ? { contactPhoneNumber: phone } : {}),
        ...(formValues.doingBusinessAs?.length ? { doingBusinessAs: formValues.doingBusinessAs } : {}),
        ...(formValues.address ? { address: formValues.address } : {}),
        ...(Object.keys(insuredFields).length > 0 ? { insuredFields } : {}),
        ...(Object.keys(exceptions).length > 0 ? { exceptions } : {}),
    };
}
